module.exports = __webpack_public_path__ + "fbeceb8d674b37d929cc4ee3d806506f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/training-groups3.jpg
// module id = 1233
// module chunks = 0